webpackJsonp([273949829873662],{

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BP_N008041.ea5d3d29.jpg";

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _BP_N = __webpack_require__(884);
	
	var _BP_N2 = _interopRequireDefault(_BP_N);
	
	var _panoramic = __webpack_require__(24);
	
	var _panoramic2 = _interopRequireDefault(_panoramic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _panoramic2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'metadata--wrapper' },
	            _react2.default.createElement('img', { src: _BP_N2.default, alt: '' }),
	            _react2.default.createElement(
	                _info2.default,
	                null,
	                'Spectateurs au Palais Montcalm. Photographe inconnu, Fond Th\xE9o Genest (AVQ), ca1943.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _imageFooterDigestif = __webpack_require__(297);
	
	var _imageFooterDigestif2 = _interopRequireDefault(_imageFooterDigestif);
	
	var _hamburger = __webpack_require__(62);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'hamburger' } }),
	            _react2.default.createElement(_sidebarLeft2.default, null),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(_hamburger2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Digestifs et bonne compagnie'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Les fruits n\xE9cessaires aux distillations ici propos\xE9es demand\xE8rent de s\xE9rieux efforts pour \xEAtre r\xE9unis. Je remercie chaleureusement tous ceux et celles qui ont pris part \xE0 la cueillette et qui l\u2019ont rendue possible. Je remercie tout sp\xE9cialement les consultants au CALQ et \xE0 T\xE9l\xE9-Qu\xE9bec qui, en 2016, ont jug\xE9 bon d\'allouer quelques fonds publics pour les capsules web. Sans eux, mon penchant \xE0 la distillation infinie l\'aurait sans doute emport\xE9. Et il \xE9tait grand temps, apr\xE8s toutes ces ann\xE9es de fermentation, que les premiers \xE9lixirs soient offerts. Ils continueront de m\xFBrir et je l\'esp\xE8re, par de nouvelles contributions et au fil des ann\xE9es, deviendront meilleurs.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'David N. Bernatchez'
	                    ),
	                    ' est cin\xE9aste, chercheur et musicien. Docteur en histoire et en anthropologie, il partage son temps entre la r\xE9alisation et la production, la recherche et l\'exp\xE9rimentation. Il est l\'id\xE9ateur principal de Ludovica.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Marco Dub\xE9'
	                    ),
	                    ' est un pilier de la production m\xE9diatique ind\xE9pendante. Artiste et bricoleur, il est un travailleur infatigable et un collaborateur aguerri. Pour Ludovica, il est monteur et infographiste.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Val\xE9riane Cossette'
	                    ),
	                    ' est une touche \xE0 tout de la recherche et de la r\xE9daction, de la conception et de la coordination. Pour Ludovica, c\'est exactement ce qu\'elle a fait: toucher \xE0 tout \xE7a.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'R\xE9jean Lemoine'
	                    ),
	                    ' est un historien et journaliste int\xE9ress\xE9 par la vie citoyenne. Pour Ludovica, il a contribu\xE9 \xE0 la r\xE9daction de plusieurs paragraphes de lieux et de personnages.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Lucie K. Morisset'
	                    ),
	                    ' est une urbaniste qui a notamment publi\xE9 un livre tr\xE8s important pour ce projet: La m\xE9moire du paysage (2001). Elle ne sait m\xEAme pas que son nom figure ici, on esp\xE8re qu\u2019elle en sera heureuse.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Elias Djemil'
	                    ),
	                    ' est un photographe et artisan de la vid\xE9o. Pour Ludovica, il a \xE9t\xE9 un interlocuteur de premi\xE8re instance: il y a malheureusement br\xFBl\xE9 sa vocation de producteur.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Hema'
	                    ),
	                    ' est une artiste audio et visuelle. Elle s\u2019int\xE9resse particuli\xE8rement \xE0 la po\xE9tique des langages: clam\xE9s, crayonn\xE9s, \xE9tudi\xE9s et commissari\xE9s. Pour Ludovica, elle est illustratrice.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Marilyn Dufour'
	                    ),
	                    ' s\u2019int\xE9resse \xE0 la conception web et \xE0 la vie citoyenne. Graphiste et webmestre de formation, elle a oeuvr\xE9 \xE0 la conception graphique du site Ludovica.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        'Fr\xE9d\xE9ric Guimont'
	                    ),
	                    ' est un artisan du dessin et de la machine. Webmestre issu de la BD, il a int\xE9gr\xE9 le site et lui a donn\xE9 vie.'
	                )
	            ),
	            _react2.default.createElement(_sidebarRight2.default, null)
	        ),
	        _react2.default.createElement(_imageFooterDigestif2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digestifs-et-bonne-compagnie-js-f2bcccf0b3ccf4ec3231.js